<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container>
          <label>Insulina de jejum (µUI/mL)</label>
          <md-input
            id="fastingInsulin"
            v-model="exam.fields.fastingInsulin"
            v-validate="'required'"
            v-mask="insulin"
            data-vv-validate-on="none"
            name="fastingInsulin"
            maxlength="5"
            title="Insulina de jejum (µUI/mL)"
            placeholder="Insulina de jejum (µUI/mL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.fastingInsulin"
            v-mask="insulin"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>Glicemia de jejum (mg/dL)</label>
          <md-input
            id="fastingBloodGlucose"
            v-model="exam.fields.fastingBloodGlucose"
            v-validate="'required'"
            v-mask="`####`"
            data-vv-validate-on="none"
            name="fastingBloodGlucose"
            maxlength="4"
            title="Glicemia de jejum (mg/dL)"
            placeholder="Glicemia de jejum (mg/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.fastingBloodGlucose"
            v-mask="`####`"
            type="hidden"
          >
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>

    <div class="calc-card__result">
      <template>
        <p>
          Resultado: <span>{{ exam.result }}</span>
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'CalcIndiceIggLiquor',
  data: () => {
    return {
      exam: {
        fields: {
          fastingInsulin: null,
          fastingBloodGlucose: null
        },
        result: 0
      },
      insulin: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 3
      })
    }
  },
  methods: {
    calculate() {
      if (this.exam.fields.fastingInsulin && this.exam.fields.fastingBloodGlucose) {
        const fastingInsulin = +this.exam.fields.fastingInsulin
        const fastingBloodGlucose = +this.exam.fields.fastingBloodGlucose

        this.exam.result = ((fastingInsulin * fastingBloodGlucose) / 22.5).toFixed(2)
      }
    }
  }
}
</script>

